export interface StripePlanConfig {
  name: string;
  productId: string;
  priceId: string;
  monthlyPrice: number;
  features: string[];
}

export interface StripePlans {
  essentiel: StripePlanConfig;
  metier: StripePlanConfig;
  pilotage: StripePlanConfig;
  daf: StripePlanConfig;
}

export const stripePlans: StripePlans = {
  essentiel: {
    name: 'Trezoone Essentiel',
    productId: 'prod_U5lJDJlglu3iKr',
    priceId: 'price_1T7ZnAIiFyVHMrOrRAdhPQSy',
    monthlyPrice: 49,
    features: [
      'Tableau de bord',
      'Trésorerie',
      'Transactions manuelles',
      'Catégorisation automatique',
      'Plan de trésorerie',
      'Scénarios de trésorerie',
      'Stress Test',
      'Fonds de Roulement Dynamique',
      'Budget prévisionnel',
      'Suivi budgétaire',
      'Multi compte bancaire'
    ]
  },
  metier: {
    name: 'Trezoone Métier',
    productId: 'prod_U5lJtNeT4T28qR',
    priceId: 'price_1T7ZnEIiFyVHMrOrtTWHNYW4',
    monthlyPrice: 59,
    features: [
      'Toutes les fonctionnalités du Pack Essentiel',
      '1 module métier activable au choix',
      'Gestion personnalisée selon votre secteur'
    ]
  },
  pilotage: {
    name: 'Trezoone Pilotage',
    productId: 'prod_U5lJsY1KsBCQbL',
    priceId: 'price_1T7Zn9IiFyVHMrOrbdQhIW3O',
    monthlyPrice: 69,
    features: [
      'Toutes les fonctionnalités du Pack Métier',
      'Rapport financier automatisé mensuel',
      'Génération PDF automatique',
      'Historique des rapports'
    ]
  },
  daf: {
    name: 'Trezoone DAF',
    productId: 'prod_U5lJbyszWorGow',
    priceId: 'price_1T7Zn9IiFyVHMrOr844HZuu3',
    monthlyPrice: 199,
    features: [
      'Toutes les fonctionnalités du Pack Pilotage',
      'Accompagnement DAF personnalisé',
      'Espace notes internes',
      'Compte-rendu mensuel dédié',
      'Support prioritaire',
      'Places limitées'
    ]
  }
};

export type PlanType = keyof StripePlans;

export function getPlanTypeFromPriceId(priceId: string): PlanType {
  const planEntries = Object.entries(stripePlans) as [PlanType, StripePlanConfig][];

  for (const [planType, config] of planEntries) {
    if (config.priceId === priceId) {
      return planType;
    }
  }

  return 'essentiel';
}

export function getPlanTypeFromProductId(productId: string): PlanType {
  const planEntries = Object.entries(stripePlans) as [PlanType, StripePlanConfig][];

  for (const [planType, config] of planEntries) {
    if (config.productId === productId) {
      return planType;
    }
  }

  return 'essentiel';
}

export function getPlanConfig(planType: PlanType): StripePlanConfig {
  return stripePlans[planType];
}
